import { render, staticRenderFns } from "./GroupLayerSimplified.vue?vue&type=template&id=3642e0e0&scoped=true"
import script from "./GroupLayerSimplified.vue?vue&type=script&lang=ts"
export * from "./GroupLayerSimplified.vue?vue&type=script&lang=ts"
import style0 from "./GroupLayerSimplified.vue?vue&type=style&index=0&id=3642e0e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642e0e0",
  null
  
)

export default component.exports